export default "__VITE_ASSET__58521468__"